export default __webpack_public_path__ + "static/media/youtube.a5c7b652.jpg";